import React from 'react';
import axios from 'axios';
import constant from "../utilities/constants.json";
import { useSetUnderMaintenance } from './useMaintenanceStatus';

const ALL_WINNERS_API = constant.server + "all_winners";
const FINAL_WINNERS_API = constant.server + "final_winners";

/**
 * Custom hook to fetch prediction contest winners
 *
 * @returns {{
 *   winners: {
 *     general_question_winners: Array<{
 *       user_id: { $oid: string },
 *       name: string,
 *       image: string
 *     }>,
 *     daily_winners: {
 *       final: Array<{ user_id: { $oid: string }, name: string, image: string }>,
 *       semi: Array<{ user_id: { $oid: string }, name: string, image: string }>,
 *       quarter: Array<{ user_id: { $oid: string }, name: string, image: string }>
 *     }
 *   } | null,
 *   finalWinners: Array<{
 *     _id: string,
 *     score: number,
 *     position: "first_place" | "second_place" | "third_place",
 *     user: {
 *       _id: { $oid: string },
 *       name: string,
 *       image: string,
 *       phone: string,
 *       country_code: string
 *     }
 *   }> | null,
 *   loading: boolean,
 *   error: any
 * }}
 */
const useWinners = () => {
  const [winners, setWinners] = React.useState(null);
  const [finalWinners, setFinalWinners] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const { setSiteUnderMaintenance } = useSetUnderMaintenance();

  React.useEffect(() => {
    const getAllWinners = async () => {
      const response = await axios.get(ALL_WINNERS_API);
      if (response?.data?.status === 1) {
        setWinners(response?.data?.data ? response.data.data : null);
      } else if (response?.data?.status === 103) {
        setSiteUnderMaintenance();
      }
    };

    const getFinalWinners = async () => {
      const response = await axios.post(FINAL_WINNERS_API);
      if (response?.data?.status === 1) {
        setFinalWinners(response?.data?.data?.winners ? response.data.data.winners : []);
      } else if (response?.data?.status === 103) {
        setSiteUnderMaintenance();
      }
    };

    const fetchAll = async () => {
      try {
        await Promise.all([getAllWinners(), getFinalWinners()]);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  return { winners, finalWinners, loading, error };
};

export default useWinners;